import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export function ThemeToggle({ className = '' }) {
  const { isDark, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      className={`p-2 rounded-xl transition-all duration-300 backdrop-blur-sm ${
        isDark
          ? 'bg-white/[0.06] hover:bg-white/[0.12] text-white/60 hover:text-white border border-white/10'
          : 'bg-black/[0.04] hover:bg-black/[0.08] text-slate-500 hover:text-slate-700 border border-black/10'
      } ${className}`}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
